import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _Set from 'babel-runtime/core-js/set';
export default function signal() {
  var listeners = new _Set();

  return {
    subscribe: function subscribe(fn) {
      if (typeof fn !== 'function') {
        throw new Error('The argument is not a function');
      }
      listeners.add(fn);
      return function () {
        return listeners.delete(fn);
      };
    },
    dispatch: function dispatch() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      listeners.forEach(function (listener) {
        listener.apply(undefined, _toConsumableArray(args));
      });
    }
  };
}